import { axiosClient } from '../../services/axiosInstance'
import { retryTransient } from '../../utils/pdp/retryTransient'

export const fetchAPI = async <T>(url: string): Promise<T> => {
  try {
    // The CMS app sometimes answers 5xx ("Connection refused") for a moment
    // while a pod restarts (SITE-B2C-FASTSTORE-5KY); the next call succeeds.
    const response = await retryTransient(() => axiosClient.get<T>(url), {
      retries: 2,
      delayMs: 500,
    })

    return response.data
  } catch (error) {
    if (error.response) {
      console.error(error.response.data)
    } else {
      console.error(error.message)
    }

    throw new Error(`Error while fetching ${url}`, { cause: error })
  }
}
